import { createItemsData } from '../utils/request.utils'
import { HALApiService } from './hal-api.service'
import { Service } from './base-service'

export const warehouseService = new Service('/storage/warehouse', HALApiService, createItemsData)
